import { Box, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import VidletLogo from "components/VidletLogo";
import { flexCentered } from "theme/base/flex";

export default function LayoutPublic() {
  return (
    <Stack
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "grey.100",
      }}
    >
      <Box
        sx={{
          py: 2,
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          ...flexCentered,
        }}
      >
        <VidletLogo sx={{ fontSize: "2.5rem" }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          py: 4,
          px: 2,
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
}
